import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '' : 'https://collection2021.chineseplus.net/'
// axios.defaults.baseURL = ''
// axios.defaults.baseURL = 'http://iclew.chinese.cn/'
// axios.defaults.withCredentials = true  //允许axios请求携带cookie等凭证

axios.interceptors.response.use(res => {
    return res.data
})

axios.interceptors.request.use(config => {
    return config
})

let utils = {
  get: (url, parameter) => {
    return axios({
      url: url,
      method: "get",
      params: parameter,
    });
  },
  postJson: (url, parameter) => {
    return axios({
      url: url,
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      data: parameter,
    });
  },
  postForm: (url, parameter) => {
    return axios({
      url: url,
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(parameter),
    });
  },
  postFile: (url, parameter) => {
    // const _data = new FormData()
    // for (const key in parameter) {
    //   if (parameter.hasOwnProperty(key)) _data.append(key, parameter[key])
    // }

    return axios({
      url: url,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: parameter,
    });
  },
  downFile: (url, parameter) => {
    return axios({
      url: url,
      params: parameter,
      method: "get",
      responseType: "blob",
    });
  },
};

Vue.prototype.$utils = utils